exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".chart-legend {\n  width: 205px;\n}\n.chart-legend .chart-header {\n  color: #2a2a2f;\n  font-size: 12px;\n  font-weight: 500;\n  padding: 16px 24px;\n}\n", ""]);

// exports
